/**
 * All types allowed as an event property.
 *
 */
type TScalarEventProperty = string | number | boolean | Date | Record<string, string>;
export type TEventProperty = TScalarEventProperty | TScalarEventProperty[];

/**
 * The type used for tracking event properties through {@link actions.ts}.
 */
export type TEventProperties = { [key: string]: TEventProperty };

export type TPageViewEventProperties = { [key: string]: TEventProperty | undefined | null };

export interface IPageViewProps {
  pageName: string;
  properties: TPageViewEventProperties;
}

export interface ILogPageViewProps extends IPageViewProps {
  loggingIsEnabled?: boolean;
  uniquePageId?: string;
}

/**
 * Interface used while identifying a user
 */
export interface IIdentifyUserProps {
  patientId: string;
  isColorEmployee?: boolean;
  properties?: TEventProperties;
}

/**
 * Tracking event type
 */
export enum EventType {
  IDENTIFY = 'identify',
  PAGE = 'page',
  RESET = 'reset',
  TRACK = 'track',
}
